export const CURRENT_CONFIG = {

  // license
  appId: '152669', // You need to go to the development website to apply.
  appKey: '16ec90532895a85e580c9c739bfe635', // You need to go to the development website to apply.
  appLicense: 'Lxll1dOaUB11+4AhrOmdvdUZ86BPPvUzjY1MvQ0JH/KDUnFsx5USU2Mh36iGfRKTS3DW5nlh/vVpyBd3shj3CyiEZrVfPtXPR2vUP4NtEdFxd3JpslYcqqFtUVJLYnuD5H1IuH9Llm68Tv6Bo64kCJGxLFhq4nNEcue1nilo95k=', // You need to go to the development website to apply.

  // http
  baseURL: 'https://remote-api.hightek.it/',                       // 👈 niente porta, HTTPS
  websocketURL: 'wss://remote-api.hightek.it/api/v1/ws',           // 👈 wss, non ws

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://185.203.25.236:1935/live?user=myuser&pass=mypass', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
//gbServerIp: '192.168.52.66',
  gbServerIp: '185.203.25.236',
  gbServerPort: '5060',
  gbServerId: '34020000002000000001',
  gbAgentId: '34020000001110000001',
  gbPassword: 'password123',
  gbAgentPort: '15060',
  gbAgentChannel: '1',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
